import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { templatesClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Templates($search: String, $page: Int, $filter: TemplateFilter) {
    templates(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      type
      key
    }
  }
`

const useTemplatesLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: templatesClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'templates']))
  }
}

const TemplateSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useTemplatesLoader(filter)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      {...props}
    />
  )
}

export default TemplateSelect
